import { render, staticRenderFns } from "./SaleInfo.vue?vue&type=template&id=dfbf9894&scoped=true"
import script from "./SaleInfo.vue?vue&type=script&lang=js"
export * from "./SaleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbf9894",
  null
  
)

export default component.exports